import HomecardMap from './HomecardMap';

export default HomecardMap;
